function SubHeader(props) {
    return (
        <h2 className="text-3xl lg:text-4xl font-semibold text-blue">{props.children}</h2>
    )
}

export default SubHeader